import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "filename", "submit", "loading"]

    select() {
        const file = this.inputTarget.files[0]

        if (file) {
            this.filenameTarget.textContent = file.name
            this.submitTarget.classList.remove("hidden")
        } else {
            this.filenameTarget.textContent = "ファイル未選択"
            this.submitTarget.classList.add("hidden")
        }
    }

    async submit(event) {
        event.preventDefault()

        this.loadingTarget.classList.remove("hidden")
        this.submitTarget.querySelector("input").disabled = true

        try {
            const form = event.target
            const formData = new FormData(form)

            const response = await fetch(form.action, {
                method: "POST",
                body: formData,
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    "Accept": "application/json"
                }
            })

            const data = await response.json()

            if (!response.ok) {
                throw new Error(data.error)
            }

            window.open(data.csv_url, "_blank")
            Turbo.visit(data.redirect_url)
        } catch (e) {
            this.loadingTarget.classList.add("hidden")
            this.submitTarget.querySelector("input").disabled = false
            alert("CSVの変換に失敗しました。" + e)
        }
    }
}